import React, { Component } from 'react';
import { Button, Modal, TextInput, FileUpload } from 'react-responsive-ui'
import PropTypes from 'prop-types';
import NewPost from '../components/newsline/newPost';
import PostsList from '../components/newsline/postsList';
import {getNewslinePosts,
     doDeletePost,
    doUpdatePost} from '../helpers/registrationHelper';
import Loading from '../components/Loading';
import More from '../components/more';

class Newsline extends Component {

    constructor(props) {
        super(props);
        this.props = props
        this.state = { posts: [], isEditingPost: false,
        ableToLoadMore: true, showLoadMore: false}
        this.savePost = this.savePost.bind(this)
        this.deletePost = this.deletePost.bind(this)
        this.handleEditPost = this.handleEditPost.bind(this)
        this.doHandleEditPost = this.doHandleEditPost.bind(this)
        this.handleUpdatePostText = this.handleUpdatePostText.bind(this)
        this.handleUpdatePostLink = this.handleUpdatePostLink.bind(this)
    }

    render() {
        if (!this.state) {
            return <Loading />
        } else {
            return (
                <div className="newsline-wrapper">
                    <NewPost {...this.props} savePost={this.savePost} />
                    {this.state.showImageModal && <Modal
                        isOpen={this.state.showImageModal}
                        close={() => this.setState({ showImageModal: false })}>
                        {this.state.editing_post.photo && <FileUpload
                            action={(file) => {
                                this.setState({ file: file })

                                var reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = function () {
                                    let picture = reader.result
                                    this.setState({ picture: picture })
                                    var newPost = Object.assign({}, this.state.editing_post);   
                                    newPost.photo = picture
                                    this.setState({editing_post: newPost})
                                }.bind(this);
                                reader.onerror = function (error) {
                                    console.log('Error: ', error);
                                };
                            }
                            }
                            className={`file-upload`}>
                            Click here to change picture
                                </FileUpload>
                            }
                        {this.state.editing_post.photo && <img className="image-preview" alt="Preview Image Unavailable" src={this.state.editing_post.photo} />}
                        <TextInput
                            placeholder={this.state.editing_post.text && this.state.editing_post.text}
                            value={this.state.editing_post.text}
                            onChange={this.handleUpdatePostText} />
                        <TextInput
                            placeholder={this.state.editing_post.link_url && this.state.editing_post.link_url}
                            value={this.state.editing_post.link_url}
                            onChange={this.handleUpdatePostLink} />
                        <Button action={this.doHandleEditPost}>
                            Update
                                </Button>
                    </Modal>
                    }
                    <PostsList {...this.props} posts={this.state.posts} deletePost={this.deletePost} doUpdatePost={this.handleEditPost} />
                    { this.state.showLoadMore &&
                    <More loadMore={ this.loadMore } ableToLoadMore={this.state.ableToLoadMore}/>}
                </div>
            )
        }
    }

    loadMore = (pageNumber) => {
        getNewslinePosts(pageNumber)
            .then((response) => {
                if (!response.data.error) {
                    if(response.data.length > 0 ) {
                        this.setState(prevState => ({ posts: prevState.posts.concat(response.data) }))
                    }
                        else
                        this.setState({ ableToLoadMore: false})

                } else {
                    console.log('get posts errored')
                }
            })
    }

    handleUpdatePostText(value) {
        let newPost = this.state.editing_post
        newPost.text = value;
        this.setState({ editing_post: newPost})
    }
    
    handleUpdatePostLink(value) {
        let newPost = this.state.editing_post
        newPost.link_url = value;
        this.setState({ editing_post: newPost})
    }

    savePost(new_post) {
        var newPosts = this.state.posts.concat(new_post);
        this.setState({ posts: newPosts });
    }
    
    handleEditPost(post_id) {
        let _posts = this.state.posts.filter(function (post) {
            return post.id === post_id
        });
        let editing_post =  Object.assign({}, _posts[0]);   
        this.setState({ editing_post: editing_post, editing_id: post_id, showImageModal: true })
    }

    doHandleEditPost(){
        let editing_post = this.state.editing_post;
        let editing_id = this.state.editing_id;
        let _posts = this.state.posts
        _posts.forEach(function (post) {
            if (post.id === editing_id) {
                post.photo = editing_post.photo
                post.text = editing_post.text
                post.link_url = editing_post.link_url
            }
            return post;
        });
        doUpdatePost(this.state.editing_id, this.state.editing_post)
        .then((response) => {
            if (!response.data.error) {
                this.setState({ showImageModal: false, posts: _posts})
            } else {
                console.log('get posts errored')
            }
        })
    
    }

    deletePost(post_id) {
        doDeletePost(post_id)
        .then((response) => {
            if(response.data.success) {
                
                var newPosts = this.state.posts.filter(function( post ) {
                    return post.id !== post_id
                 });
                this.setState({ posts: newPosts });
            }
        })
    }

    componentDidMount() {
        getNewslinePosts()
            .then((response) => {
                if (!response.data.error) {
                    this.setState({ posts: response.data, showLoadMore: true })
                } else {
                    console.log('get posts errored')
                }
            })
    }
}
Newsline.propTypes = {
    history: PropTypes.object
};

export default Newsline;



// WEBPACK FOOTER //
// ./src/view/newsline.js